import { AttioTeamMemberResponse } from '../attio.types';
import { BaseAttioService } from './BaseAttioService';

// Service-specific types
export interface AttioTeamData {
  name: string;
  imageSrc: string;
  email?: string;
}

export class AttioTeamService extends BaseAttioService {
  constructor() {
    super('AttioTeamService');
  }

  /**
   * Get team member details by record ID
   */
  async getTeamMember(teamRecordId: string, signal?: AbortSignal): Promise<AttioTeamData> {
    try {
      if (teamRecordId) {
        const teamResponse = await this.get<AttioTeamMemberResponse>(
          this.endpoints.retrieveTeamByRecordId(teamRecordId),
          signal
        );

        const teamData = teamResponse.data.values;

        return {
          name: teamData.name?.[0]?.value || '-',
          imageSrc: teamData.profile_image_url?.[0]?.value || '-',
          email: teamData.email?.[0]?.value || undefined,
        };
      }

      // Default values if no team record ID provided
      return {
        name: '-',
        imageSrc: '-',
      };
    } catch (error) {
      console.warn('Error fetching team member details:', error);
      return {
        name: '-',
        imageSrc: '-',
      };
    }
  }
}
